<p-sidebar
  [(visible)]="visible"
  (visibleChange)="visibleChange.emit($event)"
  position="right"
  [modal]="true"
  [dismissible]="true"
  [showCloseIcon]="true"
  [blockScroll]="true"
  styleClass="prizes-filters-drawer"
>
  <ng-template pTemplate="header">
    <span class="font-bold">Filters</span>
  </ng-template>

  <div class="drawer-content">
    <div class="guardrails">
      <p class="guardrails-label">Run guardrails</p>
      <div class="guardrail-tags">
        <span class="guardrail-tag">Max {{ maxDays }} days</span>
        <span class="guardrail-tag">Max {{ maxPrizesPerDay }} prizes/day</span>
        <span class="guardrail-tag">Max {{ maxOccurrencesPerCategoryInDailyPool }} per category (Daily Prize Weights)</span>
        <span class="guardrail-tag">Max {{ maxOccurrencesPerCategoryInRemainingPool }} per category (Remaining Prize Weights)</span>
      </div>
    </div>

    <div *ngIf="filtersLoaded; else filtersLoading" class="filters-section-body">
      <app-prize-weights-filter
        sectionKey="dailyPrizeWeights"
        sectionTitle="Daily Prize Weights"
      ></app-prize-weights-filter>

      <app-prize-weights-filter
        sectionKey="remainingPrizeWeights"
        sectionTitle="Remaining Prize Weights"
      ></app-prize-weights-filter>

      <app-prize-date-filter></app-prize-date-filter>

      <app-prize-tag-filter></app-prize-tag-filter>
    </div>
    <ng-template #filtersLoading>
      <div class="filters-loading">
        <i class="pi pi-spin pi-spinner" aria-hidden="true"></i>
        Loading saved filters…
      </div>
    </ng-template>

    <div class="drawer-actions">
      <button
        pButton
        pRipple
        type="button"
        label="Save Filters"
        icon="pi pi-save"
        class="p-button-outlined"
        [disabled]="!filtersLoaded"
        pTooltip="Saves this filter configuration as the active default for every operator."
        tooltipPosition="top"
        (click)="onSaveFilters()"
      ></button>
      <button
        pButton
        pRipple
        type="button"
        label="Apply to Next Rerun"
        icon="pi pi-check"
        [disabled]="!filtersLoaded"
        pTooltip="Uses these filters for the next Regenerate Unselected — does not save them as the new default."
        tooltipPosition="top"
        (click)="onApplyToNextRerun()"
      ></button>
    </div>
  </div>
</p-sidebar>
